import { render } from "./purchaseCRUD.vue?vue&type=template&id=dbcb7938&scoped=true"
import script from "./purchaseCRUD.vue?vue&type=script&lang=js"
export * from "./purchaseCRUD.vue?vue&type=script&lang=js"

import "./purchaseCRUD.vue?vue&type=style&index=0&id=dbcb7938&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbcb7938"]])

export default __exports__